import * as types from "./types";
import {
  getByDriver,
  getByDriverMonth,
  bulkUpload,
  createNPS,
  deleteNPS,
} from "./services";

export async function getByDriverAction({ commit }, payload) {
  commit(types.PROCESSING_DRIVER_NPS, true);

  let state = {
    success: false,
    message: null,
    data: null,
  };

  try {
    const { data } = await getByDriver(payload);
    commit(types.GET_DRIVER_NPS, data);
    state.success = true;
    state.data = data;
  } catch (e) {
    console.error(e);
    state.message = e.error;
  } finally {
    commit(types.PROCESSING_DRIVER_NPS, false);
  }

  return state;
}

export async function getByDriverMonthAction({ commit }, payload) {
  commit(types.PROCESSING_DRIVER_NPS, true);

  let state = {
    success: false,
    message: null,
    data: null,
  };

  try {
    const { data } = await getByDriverMonth(payload.id, payload.month);
    commit(types.GET_DRIVER_NPS, data);
    state.success = true;
    state.data = data;
  } catch (e) {
    console.error(e);
    state.message = e.error;
  } finally {
    commit(types.PROCESSING_DRIVER_NPS, false);
  }

  return state;
}

export async function bulkUploadAction({ commit }, payload) {
  commit(types.PROCESSING_BULK_DRIVER_INVOICE, true);

  let state = {
    success: false,
    message: null,
    data: null,
  };

  try {
    const { data } = await bulkUpload(payload);
    commit(types.DRIVER_INVOICES, data);
    state.success = true;
    state.data = data;
  } catch (e) {
    console.error(e);
    state.message = e.error;
  } finally {
    commit(types.PROCESSING_BULK_DRIVER_INVOICE, false);
  }

  return state;
}

export async function createNPSAction({ commit }, payload) {
  commit(types.PROCESSING_DRIVER_NPS, true);

  let state = {
    success: false,
    data: null,
    message: null,
  };
  try {
    const { data } = await createNPS(payload);
    commit(types.CREATE_DRIVER_NPS, data);
    state.data = data;
    state.success = true;
  } catch (e) {
    console.error(e);
    state.message = e;
  } finally {
    commit(types.PROCESSING_DRIVER_NPS, false);
  }

  return state;
}

export async function deleteNPSAction({ commit }, payload) {
  commit(types.PROCESSING_DRIVER_NPS, true);

  let state = {
    success: false,
    message: null,
  };
  try {
    const { data } = await deleteNPS(payload.id);
    commit(types.DELETE_DRIVER_NPS, data);
    state.success = true;
  } catch (e) {
    console.error(e);
    state.message = e;
  } finally {
    commit(types.PROCESSING_DRIVER_NPS, false);
  }

  return state;
}
